import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../css/documentation2.css';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { useParams } from 'react-router-dom';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { APP_VERSION } from '../../constants';
import { groupBy } from '../../utlis';

const SysFeatures = () => {
  const [reportData, setReportData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { _id, type } = useParams();
  const token = getToken();
  const companyName = decodeToken(token, 'companyName');
  const companyLogo = decodeToken(token, 'logo');

  useEffect(() => {
    const fetchReportData = async () => {
      axios
        .get(`${API_URL}/${ENDPOINTS.SYS}/sys-features/${_id}/${type}`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        })
        .then((response) => {
          //  console.log(response.data);
          //  console.log('fields:', response.data.fields);
          // setReportData(response.data);
          setReportData(groupBy(response.data, 'category'));
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching user guide data:', error);
          setLoading(false);
        });
    };

    fetchReportData();
  }, []);

  if (loading) {
    return <p>Loading report documentation...</p>;
  }

  if (error) {
    return <p>Error fetching report data: {error}</p>;
  }

  if (Object.keys(reportData).length === 0) {
    return <p>No data available.</p>;
  }

  console.log('reportData:', reportData);
  return (
    <div className="documentation-container">
      <div className="text-center" style={{ marginTop: '20px' }}>
        <img
          src={`${API_URL}/${companyLogo}`}
          alt={companyName}
          className="rounded-circle"
        />

        <h1 className="title">{companyName}</h1>
        <br />
        <h3>System Features</h3>

        <h6>Version: {APP_VERSION}</h6>
        <br />

        <h5>Powered by Kaafiye Technology Center</h5>
      </div>

      {reportData &&
        Object.entries(reportData).map(([category, items]) => (
          <div key={category}>
            <h4>{category} Module's Features</h4>
            {Object.entries(
              items.reduce((acc, report) => {
                // Group reports by sub_category
                const subCategory = report.sub_category || '';
                if (!acc[subCategory]) {
                  acc[subCategory] = [];
                }
                acc[subCategory].push(report);
                return acc;
              }, {})
            ).map(([subCategory, reports]) => (
              <div key={subCategory}>
                <h5>{subCategory}</h5>
                <ul className="list-group">
                  {reports
                    // Sort reports based on the order_by field
                    .sort((a, b) => a.order_by - b.order_by)
                    .map((report, index) => (
                      <li key={index} className="list-group-item">
                        {report.form_serial}. {report.form_name}
                      </li>
                    ))}
                </ul>
              </div>
            ))}
          </div>
        ))}
    </div>
  );
};

export default SysFeatures;
